import { render, staticRenderFns } from "./RoleTasks.vue?vue&type=template&id=24349d2d&"
import script from "./RoleTasks.vue?vue&type=script&lang=js&"
export * from "./RoleTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports